import * as Yup from 'yup';
import { t } from 'utils/i18n';
import { SAVE, CascadeReportAction } from 'constants/actions';

export const actions = [{ id: SAVE, title: t(SAVE), show: 'always' }];

export const initialValues = {
  companyCode: null,
  action: CascadeReportAction.DOWNLOAD_FILE,
  email: null,
};

export const validationSchema = Yup.object().shape({
  companyCode: Yup.object()
    .shape({
      id: Yup.string(),
      name: Yup.string(),
    })
    .nullable()
    .required(t('requiredField')),
  action: Yup.string(),
  email: Yup.object()
    .nullable()
    .when('action', {
      is: (value) => value === CascadeReportAction.SEND_EMAIL,
      then: Yup.object().required(t('requiredField')),
    }),
});
